import { render, staticRenderFns } from "./company-item.vue?vue&type=template&id=aac233f2&scoped=true&"
import script from "./company-item.vue?vue&type=script&lang=js&"
export * from "./company-item.vue?vue&type=script&lang=js&"
import style0 from "./company-item.vue?vue&type=style&index=0&id=aac233f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac233f2",
  null
  
)

export default component.exports